import { useState } from "react";
import ImageLoader from "../../assets/images/fugus-logo.webp";

const LazyImage = ({ src, alt = "", loaderSize = "140px", ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Responsive loader size based on screen width
  const getResponsiveLoaderSize = () => {
    if (typeof window !== "undefined") {
      const width = window.innerWidth;
      if (width < 480) return "80px";
      if (width < 768) return "120px";
      if (width < 1024) return "140px";
      return "150px";
    }
    return loaderSize;
  };

  const responsiveSize = getResponsiveLoaderSize();

  return (
    <>
      {!isLoaded && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "2Ovh",
            position: "absolute",
            top: "20%",
            left: "50%",
            transform: "translate(-50%, -20%)",
          }}
        >
          <img
            src={ImageLoader}
            alt="Loading..."
            style={{
              width: responsiveSize,
              height: responsiveSize,
              opacity: "0.55",
            }}
          />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
        style={{ opacity: isLoaded ? 1 : 0, ...props.style }}
        {...props}
        className="rounded-16 category-image"
      />
    </>
  );
};

export default LazyImage;
